// store-match.js — which TMG Equipment store a postal code belongs to.
//
// Every place on the site that sends a visitor to a store asks this one
// file: the header's pickup flyout (header.js), the homepage "National
// inventory" band (home-network.js), the store locator (locator.js) and the
// hidden nearest_store field on the inquiry forms (routing.js). A visitor
// therefore gets the same store from all four, and a change to the areas
// is one table, not four.
//
// THE RULE is the operations team's 250 km FSA rule (TMG_Canada_250km_FSA_Store_Routing.xlsx,
// sheet "Stores & Method"):
//   - the FSA is the first three characters of a Canadian postal code;
//   - an FSA belongs to a store when its representative point is within
//     250 km of that store in a straight line — the nearer store if two
//     qualify;
//   - every other FSA is outside all store areas. Those visitors stay with
//     head office and the online store; they are deliberately not sent to a
//     store hundreds of kilometres away.
//
// The block between the <generated> markers is written by
// scripts/build-store-routing.py from that workbook and GeoNames' FSA
// points: every FSA that belongs to a store, with its point (for the
// "38 km" the band and the locator print). Never edit it by hand — change
// the workbook or the script and rerun it.
//
// Loaded as a classic deferred script by site-header.liquid, just ahead of
// header.js. Deferred scripts run in document order, so this has run before
// header.js and before any section script further down the page
// (home-network.js, locator.js, routing.js) looks for it.
//
// window.TMG_STORE_MATCH
//   match(text)   null when text is not a postal code. Otherwise
//                   inside a store area:  { code: 'V6X', store: 'richmond',
//                     name: 'Richmond, BC', city: 'Richmond', km: 2.6,
//                     lat, lng }   (lat/lng = the FSA's point)
//                   outside all of them:  { code: 'R3C', store: '' }
//                 A US ZIP is a real answer with no store: { code: '98101', store: '' }.
//   keyOf(name)   the store key a merchant-typed store name refers to
//                 ("TMG Equipment — Richmond, BC" -> 'richmond'), '' if none
//   km(n)         a distance the way the site prints it: 2.6 under 10, 38 over
//   fill(t, r, storeName)
//                 a message template with [code], [store] and [km] filled in
//   save(r)       remembers r for this visitor — only the three-character
//                 FSA, in localStorage, so it follows them page to page — and
//                 fires `tmg:store` on document with r as the detail (null
//                 forgets it)
//   saved()       the remembered FSA run back through match(), so a table
//                 change re-routes a returning visitor; null when none
if (!window.TMG_STORE_MATCH) {
  (function () {
    // <generated> by scripts/build-store-routing.py — do not edit by hand
    var RADIUS_KM = 250;
    var STORES = {"oakville": {"city": "Oakville", "name": "Oakville, ON", "lat": 43.392449, "lng": -79.743953}};
    var AREAS = {
      "oakville": "K0K 44.33 -77.43 K0L 44.78 -77.97 K0M 44.86 -78.66 K7R 44.25 -76.95 K8N 44.17 -77.37 K8P 44.17 -77.4 K8R 44.14 -77.47 K8V 44.1 -77.58 " +
        "K9A 43.96 -78.17 K9H 44.32 -78.32 K9J 44.31 -78.24 K9K 44.31 -78.36 K9L 44.36 -78.32 K9V 44.35 -78.73 L0A 44.13 -78.52 L0B 44.08 -78.75 " +
        "L0C 44.21 -79.07 L0E 44.32 -79.28 L0G 44.06 -79.62 L0H 43.9 -79.16 L0J 43.86 -79.65 L0K 44.62 -79.12 L0L 44.45 -79.74 L0M 44.33 -80.03 " +
        "L0N 44.03 -80.21 L0P 43.49 -80 L0R 43.16 -79.75 L0S 42.91 -79.08 L1A 44.02 -78.4 L1B 43.92 -78.55 L1C 43.97 -78.71 L1E 43.9 -78.77 " +
        "L1G 43.92 -78.87 L1H 43.97 -78.88 L1J 43.89 -78.88 L1K 43.93 -78.83 L1L 43.96 -78.9 L1M 43.96 -78.98 L1N 43.87 -78.93 L1P 43.89 -78.97 " +
        "L1R 43.92 -78.94 L1S 43.84 -79.03 L1T 43.88 -79.05 L1V 43.86 -79.16 L1W 43.82 -79.08 L1X 43.86 -79.1 L1Y 43.96 -79.12 L1Z 43.88 -79.01 " +
        "L2A 42.9 -78.93 L2E 43.05 -79.1 L2G 43.07 -79.08 L2H 43.1 -79.14 L2J 43.13 -79.1 L2M 43.2 -79.22 L2N 43.19 -79.26 L2P 43.15 -79.21 " +
        "L2R 43.14 -79.3 L2S 43.14 -79.26 L2T 43.13 -79.23 L2V 43.11 -79.2 L2W 43.17 -79.28 L3B 42.99 -79.22 L3C 43 -79.27 L3K 42.9 -79.23 " +
        "L3M 43.2 -79.57 L3P 43.88 -79.27 L3R 43.85 -79.33 L3S 43.85 -79.26 L3T 43.82 -79.39 L3V 44.61 -79.42 L3X 44.04 -79.49 L3Y 44.06 -79.46 " +
        "L3Z 44.12 -79.57 L4A 43.97 -79.25 L4B 43.86 -79.4 L4C 43.87 -79.44 L4E 43.94 -79.43 L4G 44 -79.47 L4H 43.84 -79.56 L4J 43.82 -79.45 " +
        "L4K 43.8 -79.48 L4L 43.81 -79.6 L4M 44.4 -79.67 L4N 44.36 -79.69 L4P 44.25 -79.47 L4R 44.75 -79.88 L4S 43.9 -79.41 L4T 43.71 -79.64 " +
        "L4V 43.69 -79.61 L4W 43.64 -79.63 L4X 43.62 -79.58 L4Y 43.6 -79.59 L4Z 43.62 -79.65 L5A 43.59 -79.61 L5B 43.58 -79.63 L5C 43.56 -79.65 " +
        "L5E 43.58 -79.56 L5G 43.56 -79.59 L5H 43.54 -79.62 L5J 43.51 -79.63 L5K 43.53 -79.66 L5L 43.54 -79.69 L5M 43.56 -79.72 L5N 43.59 -79.76 " +
        "L5P 43.69 -79.62 L5R 43.61 -79.67 L5S 43.68 -79.68 L5T 43.67 -79.62 L5V 43.6 -79.69 L5W 43.63 -79.71 L6A 43.85 -79.52 L6B 43.9 -79.22 " +
        "L6C 43.9 -79.34 L6E 43.9 -79.27 L6G 43.85 -79.33 L6H 43.49 -79.71 L6J 43.48 -79.66 L6K 43.44 -79.69 L6L 43.4 -79.72 L6M 43.45 -79.76 " +
        "L6P 43.79 -79.7 L6R 43.76 -79.76 L6S 43.74 -79.73 L6T 43.72 -79.69 L6V 43.71 -79.76 L6W 43.68 -79.73 L6X 43.67 -79.81 L6Y 43.62 -79.79 " +
        "L6Z 43.73 -79.8 L7A 43.69 -79.84 L7B 43.93 -79.53 L7C 43.88 -79.86 L7E 43.88 -79.74 L7G 43.65 -79.92 L7J 43.63 -80.04 L7K 43.86 -80 " +
        "L7L 43.38 -79.77 L7M 43.43 -79.87 L7N 43.35 -79.78 L7P 43.38 -79.89 L7R 43.38 -79.84 L7S 43.32 -79.81 L7T 43.31 -79.85 L8B 43.33 -79.88 " +
        "L8E 43.22 -79.7 L8G 43.22 -79.74 L8H 43.26 -79.79 L8J 43.18 -79.72 L8K 43.22 -79.8 L8L 43.28 -79.83 L8M 43.24 -79.84 L8N 43.4 -80.02 " +
        "L8P 43.25 -79.89 L8R 43.27 -79.88 L8S 43.26 -79.92 L8T 43.22 -79.83 L8V 43.23 -79.85 L8W 43.2 -79.85 L9A 43.23 -79.87 L9B 43.21 -79.9 " +
        "L9C 43.23 -79.9 L9E 43.52 -79.88 L9G 43.18 -79.99 L9H 43.26 -79.95 L9J 44.32 -79.68 L9K 43.23 -79.94 L9L 44.11 -78.94 L9M 44.78 -79.92 " +
        "L9N 44.11 -79.5 L9P 44.1 -79.12 L9R 44.15 -79.87 L9S 44.3 -79.65 L9T 43.51 -79.88 L9V 43.96 -80.11 L9W 43.97 -80.02 L9X 44.43 -79.83 " +
        "L9Y 44.48 -80.22 L9Z 44.52 -80.02 M1B 43.81 -79.19 M1C 43.79 -79.16 M1E 43.77 -79.19 M1G 43.77 -79.21 M1H 43.77 -79.24 M1J 43.75 -79.23 " +
        "M1K 43.73 -79.26 M1L 43.71 -79.28 M1M 43.72 -79.23 M1N 43.7 -79.26 M1P 43.76 -79.27 M1R 43.75 -79.3 M1S 43.79 -79.26 M1T 43.78 -79.3 " +
        "M1V 43.82 -79.28 M1W 43.8 -79.32 M1X 43.83 -79.21 M2H 43.8 -79.36 M2J 43.78 -79.35 M2K 43.78 -79.38 M2L 43.75 -79.38 M2M 43.79 -79.41 " +
        "M2N 43.77 -79.41 M2P 43.75 -79.4 M2R 43.78 -79.44 M3A 43.75 -79.33 M3B 43.74 -79.36 M3C 43.73 -79.33 M3H 43.75 -79.45 M3J 43.77 -79.49 " +
        "M3K 43.74 -79.47 M3L 43.73 -79.51 M3M 43.73 -79.49 M3N 43.76 -79.52 M4A 43.73 -79.31 M4B 43.71 -79.31 M4C 43.69 -79.31 M4E 43.68 -79.29 " +
        "M4G 43.71 -79.36 M4H 43.71 -79.35 M4J 43.69 -79.34 M4K 43.68 -79.35 M4L 43.67 -79.32 M4M 43.66 -79.34 M4N 43.73 -79.39 M4P 43.71 -79.39 " +
        "M4R 43.71 -79.41 M4S 43.7 -79.39 M4T 43.69 -79.39 M4V 43.69 -79.4 M4W 43.68 -79.37 M4X 43.67 -79.37 M4Y 43.67 -79.38 M5A 43.66 -79.36 " +
        "M5B 43.66 -79.38 M5C 43.65 -79.38 M5E 43.65 -79.38 M5G 43.66 -79.39 M5H 43.65 -79.38 M5J 43.62 -79.39 M5K 43.65 -79.38 M5L 43.65 -79.38 " +
        "M5M 43.73 -79.42 M5N 43.71 -79.42 M5P 43.7 -79.41 M5R 43.67 -79.4 M5S 43.66 -79.4 M5T 43.65 -79.4 M5V 43.64 -79.4 M5W 43.64 -79.38 " +
        "M5X 43.65 -79.38 M6A 43.72 -79.45 M6B 43.71 -79.45 M6C 43.69 -79.43 M6E 43.69 -79.45 M6G 43.67 -79.42 M6H 43.67 -79.44 M6J 43.65 -79.42 " +
        "M6K 43.64 -79.43 M6L 43.71 -79.49 M6M 43.69 -79.49 M6N 43.67 -79.48 M6P 43.66 -79.46 M6R 43.65 -79.45 M6S 43.65 -79.48 M7A 43.66 -79.39 " +
        "M7Y 43.78 -79.25 M8V 43.61 -79.5 M8W 43.6 -79.54 M8X 43.65 -79.51 M8Y 43.63 -79.49 M8Z 43.63 -79.52 M9A 43.67 -79.53 M9B 43.65 -79.55 " +
        "M9C 43.64 -79.58 M9L 43.76 -79.56 M9M 43.74 -79.54 M9N 43.71 -79.52 M9P 43.69 -79.53 M9R 43.69 -79.56 M9V 43.74 -79.59 M9W 43.71 -79.59 " +
        "N0A 42.94 -79.94 N0B 43.56 -80.44 N0C 44.26 -80.5 N0E 42.66 -80.56 N0G 44 -81.07 N0H 44.69 -81.1 N0J 42.98 -80.71 N0K 43.51 -81.16 " +
        "N0L 42.76 -81.45 N0M 43.28 -81.54 N0N 42.91 -82.11 N0P 42.4 -81.91 N1A 42.9 -79.62 N1C 43.49 -80.23 N1E 43.57 -80.24 N1G 43.52 -80.23 " +
        "N1H 43.56 -80.3 N1K 43.53 -80.31 N1L 43.52 -80.19 N1M 43.7 -80.37 N1P 43.34 -80.3 N1R 43.37 -80.22 N1S 43.36 -80.33 N1T 43.38 -80.28 " +
        "N2A 43.44 -80.42 N2B 43.46 -80.45 N2C 43.42 -80.45 N2E 43.41 -80.5 N2G 43.44 -80.49 N2H 43.46 -80.48 N2J 43.5 -80.54 N2K 43.5 -80.49 " +
        "N2L 43.47 -80.55 N2M 43.44 -80.51 N2N 43.43 -80.54 N2P 43.39 -80.43 N2R 43.38 -80.49 N2T 43.45 -80.57 N2V 43.48 -80.58 N2Z 44.17 -81.6 " +
        "N3A 43.4 -80.65 N3B 43.6 -80.55 N3C 43.44 -80.26 N3E 43.42 -80.35 N3H 43.43 -80.37 N3L 43.2 -80.38 N3P 43.18 -80.24 N3R 43.17 -80.27 " +
        "N3S 43.14 -80.24 N3T 43.13 -80.33 N3V 43.17 -80.3 N3W 43.07 -79.93 N3Y 42.83 -80.3 N4B 42.85 -80.5 N4G 42.86 -80.73 N4K 44.57 -80.94 " +
        "N4L 44.6 -80.58 N4N 44.15 -81.03 N4S 43.14 -80.73 N4T 43.15 -80.73 N4V 43.12 -80.74 N4W 43.73 -80.95 N4X 43.27 -81.17 N4Z 43.36 -81.01 " +
        "N5A 43.37 -80.95 N5C 43.03 -80.88 N5H 42.77 -80.98 N5L 42.67 -81.22 N5P 42.78 -81.18 N5R 42.76 -81.18 N5V 43.02 -81.16 N5W 42.99 -81.18 " +
        "N5X 43.04 -81.24 N5Y 43.01 -81.23 N5Z 42.97 -81.21 N6A 43 -81.26 N6B 42.98 -81.24 N6C 42.96 -81.24 N6E 42.92 -81.22 N6G 43.01 -81.3 " +
        "N6H 42.99 -81.34 N6J 42.95 -81.27 N6K 42.95 -81.34 N6L 42.87 -81.25 N6M 42.96 -81.14 N6N 42.9 -81.16 N6P 42.89 -81.32 N7A 43.75 -81.72 " +
        "N7G 42.96 -81.62 N7L 42.42 -82.2 N7M 42.42 -82.12 N7S 42.99 -82.36 N7T 42.96 -82.28 N7V 43 -82.39 N7W 42.96 -82.33 N7X 43.02 -82.32 " +
        "N8A 42.59 -82.39 P0A 45.59 -79.35 P0B 45.19 -79.41 P0C 45.13 -79.79 P0E 44.86 -79.51 P1H 45.33 -79.22 P1L 45.03 -79.32 P1P 44.92 -79.37 " +
        "P2A 45.35 -80.03"
    };
    // </generated>

    var SAVE_KEY = 'tmg:postal';

    // A Canadian postal code, whole or cut short anywhere after its FSA.
    // D F I O Q U never appear in one; W and Z never lead.
    var POSTAL = /^([ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z])(?:[0-9](?:[ABCEGHJ-NPRSTV-Z][0-9]?)?)?$/;
    var ZIP = /^[0-9]{5}(?:[0-9]{4})?$/;

    // AREAS.kelowna = "V0A 50.53 -119.14 V0E ..." -> index.V0A = { store, lat, lng }
    var index = {};
    Object.keys(AREAS).forEach(function (store) {
      var t = AREAS[store].split(' ');
      for (var i = 0; i + 2 < t.length; i += 3) {
        index[t[i]] = { store: store, lat: parseFloat(t[i + 1]), lng: parseFloat(t[i + 2]) };
      }
    });

    function toRad(deg) {
      return (deg * Math.PI) / 180;
    }

    // Great-circle distance: the workbook's own distance basis.
    function haversineKm(lat1, lng1, lat2, lng2) {
      var dLat = toRad(lat2 - lat1);
      var dLng = toRad(lng2 - lng1);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function match(text) {
      var s = String(text == null ? '' : text).toUpperCase().replace(/[\s-]+/g, '');
      if (ZIP.test(s)) return { code: s.slice(0, 5), store: '' };
      var m = POSTAL.exec(s);
      if (!m) return null;
      var hit = index[m[1]];
      var st = hit && STORES[hit.store];
      if (!st) return { code: m[1], store: '' };
      return {
        code: m[1],
        store: hit.store,
        name: st.name,
        city: st.city,
        lat: hit.lat,
        lng: hit.lng,
        km: haversineKm(hit.lat, hit.lng, st.lat, st.lng)
      };
    }

    function keyOf(name) {
      var slug = '-' + String(name == null ? '' : name).toLowerCase();
      if (slug.normalize) slug = slug.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      slug = slug.replace(/[^a-z0-9]+/g, '-') + '-';
      for (var key in STORES) {
        if (Object.prototype.hasOwnProperty.call(STORES, key) && slug.indexOf('-' + key + '-') !== -1) return key;
      }
      return '';
    }

    function km(n) {
      return n < 10 ? String(Math.round(n * 10) / 10) : String(Math.round(n));
    }

    function fill(template, r, storeName) {
      return String(template == null ? '' : template)
        .split('[code]').join(r ? r.code : '')
        .split('[store]').join(storeName || (r && r.name) || '')
        .split('[km]').join(r && r.store ? km(r.km) : '');
    }

    function save(r) {
      try {
        if (r) window.localStorage.setItem(SAVE_KEY, r.code);
        else window.localStorage.removeItem(SAVE_KEY);
      } catch (e) {
        // Storage blocked (private mode, site data off): the match still
        // applies to this page, it just is not remembered.
      }
      var event;
      try {
        event = new CustomEvent('tmg:store', { detail: r || null });
      } catch (e) {
        return;
      }
      document.dispatchEvent(event);
    }

    function saved() {
      var code = null;
      try {
        code = window.localStorage.getItem(SAVE_KEY);
      } catch (e) {
        return null;
      }
      return code ? match(code) : null;
    }

    window.TMG_STORE_MATCH = {
      match: match,
      keyOf: keyOf,
      km: km,
      fill: fill,
      save: save,
      saved: saved,
      radiusKm: RADIUS_KM
    };
  })();
}
